import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BrandComponent } from './components';

@NgModule({
    imports: [
        RouterModule,
    ],
    declarations: [
        BrandComponent,
    ],
    exports: [
        BrandComponent,
    ],
})

export class BrandModule {}
